import Button from "../../Shared/Button/Button";

const PaidListingFeesRow = () => {
  return (
    <div className="grid grid-cols-[90px_420px_auto_100px_200px] border border-t-0 border-lightGray px-6 py-5">
      <p className="flex items-center font-pop text-xs font-medium text-gray">
        388211
      </p>
      <p className="flex items-center font-pop text-sm font-semibold text-black">
        11/14/2022 2:33 AM ET Mens Designer Socks (334398)
      </p>
      <p className="flex items-center font-pop font-medium text-gray">
        R125.00
      </p>
      <Button
        text="New"
        className=" bg-paidNewBtn bg-opacity-40 !text-sm !font-medium !text-paidNewBtn"
      />
      <div className="flex gap-3">
        <Button
          text="Buyer Info"
          variant="blue"
          className="!w-full  !text-sm !font-medium"
        />
        <Button
          text="View"
          variant="secondary"
          className="!w-full !text-sm !font-medium"
        />
      </div>
    </div>
  );
};

export default PaidListingFeesRow;
